import React, { Component } from 'react';
import Relay from 'react-relay/classic';
import Radium, { Style } from 'radium';
import CircularProgressbar from 'react-circular-progressbar';
import find from 'lodash/find';

import CardCell from './CardCell';
import Icon from '../../../helper/Icon';

const styles = {
  container: {
    // marginBottom: '2px',
    borderBottom: '1px solid var(--color-indexLine)'
  },
  sectionCardsHiddenContainer: {
    transition: 'all 0.3s',
    opacity: 0,
    minHeight: '0px'
  },
  sectionCardsVisibleContainer: {
    opacity: 1,
    minHeight: '20px'
  },
  noBorder: {
    borderBottom: 'none'
  },
  labelText: {
    flexDirection: 'column'
    // marginLeft: '5px',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',
    // whiteSpace: 'nowrap',
    // maxWidth: '180px',
  },
  labelTimeContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  rightContainer: {
    marginLeft: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: '4px',
    flexShrink: '0'
  },
  activeSectionIndication: {
    backgroundColor: '#37b600',
    height: '10px',
    width: '10px',
    borderRadius: '50%',
    marginRight: '10px'
    /* position: 'absolute',
    top: '0px',
    left: '0px', */
  },
  cardsNumber: {
    color: 'rgba(255, 255, 255, 0.639216)',
    fontSize: '14px'
  },
  leftContainer: {
    marginRight: '11px'
  },
  completedIcon: {
    background: '#54d566',
    borderRadius: '50%',
    height: '14px',
    width: '14px',
    padding: '2px'
  },
  sectionDurationContainer: {
    fontSize: '13px',
    color: '#8392a7',
    marginLeft: '6px',
    display: 'inline-block'
    // padding: '2px 0px 0px',
  }
};

@Radium
class SectionCell extends Component {
  constructor(props) {
    super(props);

    this.state = { showCardCells: false };
    if (props.currentSection) this.state.showCardCells = true;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('nextProps.currentSection::', nextProps.currentSection);
    if (nextProps.currentSection && this.props.currentCardIndex !== nextProps.currentCardIndex) {
      this.setState({ showCardCells: true });
    }
  }

  shouldComponentUpdate(nextProps) {
    // console.log('test:', nextProps.shouldUpdate);
    if (!nextProps.shouldUpdate) return false;
    return true;
  }

  getCompletePercentage = () => {
    let sectionProgress = 0;
    const cardsLength = this.props.rootQ.cards.edges.filter(
      e => e.node.completionType !== 'OPTIONAL'
    ).length;
    this.props.rootQ.cards.edges.forEach((e) => {
      const progressMeasure = e.node.performance ? e.node.performance.scaledProgressMeasure : 0;
      sectionProgress += progressMeasure;
    });
    return (sectionProgress / cardsLength) * 100;
  };

  showSectionTitle(cardsDuration) {
    if (this.props.showSection) {
      return (
        <div
          className={'sectionInfoContainer' + (this.props.currentSection ? ' active' : '')}
          style={styles.labelWrapper}
          onClick={this.toggleSectionOpen}
        >
          <div className="sectionIconContainer">
            <span style={styles.collapseIcon}>
              <Icon
                className="sectionIcon"
                icon={this.state.showCardCells ? 'remove' : 'add'}
                fill="#929dae"
                size="24px"
              />
            </span>
          </div>
          <div style={styles.labelTimeContainer}>
            <div className="sectionLabel">
              <span style={styles.labelText}>
                {this.props.rootQ.position}
.
                {this.props.rootQ.name}
                <span style={styles.sectionDurationContainer}>
                  {cardsDuration > 59
                    ? Math.ceil(cardsDuration / 60) + ' min'
                    : Math.ceil(cardsDuration) + ' sec'}
                </span>
              </span>
            </div>
          </div>
          <div style={styles.rightContainer}>{this.renderSectionProgress()}</div>
        </div>
      );
    }
    return null;
  }

  collapseSection() {
    this.setState({ showCardCells: false }, () => (this.expanded = false));
  }

  expandSection() {
    this.setState({ showCardCells: true }, () => (this.expanded = true));
  }

  toggleSectionOpen = (e) => {
    if (this.state.showCardCells) {
      this.setState({ showCardCells: false });
    } else {
      this.setState({ showCardCells: true });
    }
    e.stopPropagation();
  };

  renderSectionProgress() {
    const percentage = this.getCompletePercentage();
    if (percentage < 100) {
      return (
        <CircularProgressbar
          className="CircularProgressbarSVG"
          percentage={percentage}
          strokeWidth={9}
          initialAnimation={false}
        />
      );
    }
    if (percentage === 100) {
      return (
        <span style={styles.completedIcon}>
          <Icon
            icon="check"
            size="10"
            viewBox="1 1 22 22"
            fill="#ffffff"
            style={{ float: 'left' }}
          />
        </span>
      );
    }
    return null;
  }

  renderCards() {
    const cards = [];
    const cardEdges = this.props.rootQ.cards.edges;
    const firstElem = false;

    // if (!this.state.showCardCells) return null;
    this.currentCardIndex = -1;
    for (let i = 0; i < cardEdges.length; i++) {
      const currentCard = cardEdges[i];
      // const nextCard = cardEdges[i + 1];
      const isCurrent = this.props.cardArray[this.props.currentCardIndex].pid === cardEdges[i].node.pid;
      if (isCurrent) this.currentCardIndex = i;
      const currentNode = find(this.props.cardInfoArray, c => c.pid === currentCard.node.pid);
      const isAccessible = currentNode ? currentNode.isAccessible : false;
      const isInSync = this.props.cardIdsInSync.includes(currentCard.node.pid);
      cards.push(
        <CardCell
          isCurrent={isCurrent}
          cardInfo={currentCard.node}
          cardTapped={this.props.cardTapped}
          key={currentCard.node.pid}
          firstElem={firstElem}
          isAccessible={isAccessible}
          isInSync={isInSync}
        />
      );
    }

    return cards;
  }

  render() {
    let cardsDuration = 0;
    this.props.rootQ.cards.edges.forEach(e => (cardsDuration += e.node.duration));

    return (
      <div
        style={[
          styles.container,
          this.state.showCardCells ? null : null,
          this.props.lastSection ? styles.noBorder : null
        ]}
      >
        {this.showSectionTitle(cardsDuration)}
        <div
          className="sectionCardsContainer"
          style={[
            styles.sectionCardsHiddenContainer,
            this.state.showCardCells ? styles.sectionCardsVisibleContainer : null
          ]}
        >
          {this.state.showCardCells ? this.renderCards() : null}
        </div>
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

export default Relay.createContainer(SectionCell, {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: variables => Relay.QL`
      fragment on Section {
        name
        position
        cards(first:100) {
          edges {
            node {
              pid
              name
              globalPosition
              hidden
              duration
              isGradable
              type
              completionType
              resource{
                type
              }
              performance(userId: $userId) {
                id
                successStatus
                completionStatus
                timeSpent
                scaledProgressMeasure
              }
            }
          }
        }
      }`
  }
});
